import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { API_URL } from '@constants';
import type { ResourcesArray } from '../components/alerts-widget.component';

@Service()
export class AlertsService {
  http = inject(HttpClient);

  getAlerts = (sort?: boolean, count?: boolean) =>
    this.http.get<ResourcesArray | { count: number }>(
      `${API_URL}/home/alerts${count ? '/count' : ''}${sort ? '?sort=1' : ''}`
    );
}
